<div class="buttons-bar">
  <button mat-icon-button color="warn" class="negative-margin" mat-dialog-close matTooltip="{{ 'btn.close' | translate }}">
    <mat-icon>close</mat-icon>
  </button>
</div>
<h1 mat-dialog-title style="text-align: center" class="mt-1">{{ "rulesList.title" | translate }}</h1>
<p class="text-center" *ngIf="!rulesSimplified?.length">
  {{ "widget.noData" | translate }}
</p>
<div style="margin: 5%" *ngIf="rulesSimplified?.length">
  <div *ngFor="let rule of rulesSimplified" class="rule-container">
    <h2
      class="rule-title"
      [innerHTML]="sanitize(rule.title)"
      *ngIf="rule.level1?.length || rule.level2?.length || rule.level3?.length || isAdmin"
    ></h2>

    <table
      mat-table
      [dataSource]="rule.nonEmptyLevels"
      class="mat-elevation-z8"
      style="width: 100%"
      *ngIf="rule.level1?.length || rule.level2?.length || rule.level3?.length"
    >
      <ng-container matColumnDef="level">
        <th mat-header-cell *matHeaderCellDef>{{ "rulesList.ruleLevel" | translate }}</th>
        <td mat-cell *matCellDef="let row">
          {{ row.label | translate }}
        </td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>{{ "rulesList.description" | translate }}</th>
        <td mat-cell *matCellDef="let row">
          <span [innerHTML]="sanitize(rule[row.key]?.join(' <b>' + ('page.questionnaireEditor.properties.or' | translate) + '</b> '))">
          </span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    <p *ngIf="!(rule.level1?.length || rule.level2?.length || rule.level3?.length) && isAdmin">
      {{ "rulesList.missingDescription" | translate }} : ({{ rule.careplans }})
    </p>
  </div>
</div>
